/*
 * Checks whether the supplied domain is either a valid root-level or sub-level domain.
 * This check will fail if a protocol (ex: https) is included in the input.
 */
export function isValidDomain(domain: string): boolean {
    if (!domain) {
        return;
    }

    var re = /^(?:[A-Za-z0-9](?:[A-Za-z0-9-]{0,61}[A-Za-z0-9])?\.){1,}[A-Za-z]{2,6}$/;
    return re.test(domain);
}
